module.exports = (__webpack_public_path__ || '') + "static/images/photo-5-76712ede3eda08a95349014a58d57075.jpg";